import {
  isSampled,
  isObject,
  isString,
  isFunction,
  matchIgnore,
  getXPath,
  getResourceErrorSrc,
  filterSerializableTypes,
} from './utils';

enum CodeEnum {
  // JS异常
  JS_ERROR = 1,
  // 接口异常
  API_ERROR = 2,
  // 资源异常	3
  RES_ERROR = 3,
  // 聚合方式: 求和/均值等
  AGGREGATE = 1000,
}

// 异常C1字段映射表
let errorC1Map = {};

/**
 * 埋点上报
 * @param apiName 上报名
 * @param params 上报参数
 */
export const report =
  (sendGoldLog: (logData: any) => void, config?: any) =>
  (apiName, ...params) => {
    if (!isFunction(sendGoldLog)) {
      return;
    }

    try {
      const {
        logKey = '/dianying.fe.monitor',
        logType = 'OTHER',
        ignoreMap,
        sampleMap,
        ...restConfig
      } = config || {};
      const baseParams = filterSerializableTypes(restConfig);
      let { code, msg, ...restParams } = isObject(apiName) ? apiName : {};
      // 兼容ARMS上报类型
      if (isString(apiName)) {
        switch (apiName) {
          /**
           * 异常：armsReport('error', e);
           */
          case 'error':
            code = CodeEnum.JS_ERROR;
            let evt = params[0] || {};
            const target = evt.target || evt.srcElement;
            const isUnhandledrejection = evt.type === 'unhandledrejection';
            if (isUnhandledrejection) {
              evt = evt.reason;
            } else if (
              typeof ErrorEvent !== 'undefined' &&
              evt instanceof ErrorEvent
            ) {
              evt = evt.error;
            }

            if (evt instanceof Error) {
              // JS ERROR
              msg = evt.message;
              restParams.d1 = evt.name;
              restParams.c1 = evt.stack;
            } else if (
              typeof HTMLElement !== 'undefined' &&
              target instanceof HTMLElement
            ) {
              // 资源加载异常：SCRIPT、LINK、IMG
              code = CodeEnum.RES_ERROR;
              const src = getResourceErrorSrc(target) || '';
              msg =
                src === (window.location && location.href)
                  ? '__EMPTY__SRC__'
                  : src;
              restParams.d1 = target.tagName?.toLowerCase();
              restParams.c1 = getXPath(target, 5);
            } else if (evt) {
              msg = evt.message || evt;
              restParams.d1 = isUnhandledrejection
                ? 'unhandledrejection'
                : 'unknownError';
            }
            // 存在C1字段
            if (restParams.c1) {
              // 相同C1的异常只上报1次，避免污染监控
              if (errorC1Map[restParams.c1]) {
                msg = '';
              } else {
                errorC1Map[restParams.c1] = 1;
              }
            }
            break;
          /**
           * 求和/均值:
           *   armsReport('sum', 'm3u8_video', 1);
           *   armsReport('avg', `${name}_timeout`, perf);
           */
          case 'sum':
          case 'avg':
            code = CodeEnum.AGGREGATE;
            msg = params[0];
            restParams.m1 = params[1] || (apiName === 'sum' ? 1 : 0);
            break;
          /**
           * 接口：armsReport('api', name, !isFailed, cost, msg, __param);
           */
          case 'api':
            code = CodeEnum.API_ERROR;
            msg = params[3];
            restParams = {
              // apiName
              d1: params[0],
              // 成功状态指标，1-成功、0-失败
              m1: params[1] ? 1 : 0,
              // 响应时间ms
              m2: params[2],
              // 接口入参和返回信息
              c1: params[4],
            };
            break;
        }
      }

      let isNeedReport = !!msg;
      // 采样处理
      if (isNeedReport && sampleMap && sampleMap[code]) {
        isNeedReport = isSampled(sampleMap[code]);
      }
      // 忽略处理
      if (isNeedReport && ignoreMap && ignoreMap[code]) {
        isNeedReport = !matchIgnore(ignoreMap[code], msg);
      }

      if (isNeedReport) {
        // 埋点上报
        sendGoldLog({
          logKey,
          logType,
          logData: {
            code,
            msg,
            ...baseParams,
            ...restParams,
          },
        });
      }
    } catch (e) {
      console.log('monitor error:', e);
    }
  };
